const activeClass = 'active';

$('.megamenu__inner > ul > li:not(.has-button)').on('mouseenter', function(event) {
  const $this = $(this);

  $this
    .addClass(activeClass)
    .siblings()
    .removeClass(activeClass)
});